import {configureStore,createSlice} from  '@reduxjs/toolkit';
import loginReducer from "../components/login/loginSlice";
import  userReducer  from "../components/backend/dashboard/userSlice";
import  passwordReducer  from "../components/login/passwordSlice";
import userCreateReducer from "../components/backend/user/userCreateSlice";
import allUserReducer from "../components/backend/user/allUserSlice";
//import userProfileReducer from "../components/backend/user/userProfileSlice";
import userModifyReducer from "../components/backend/user/userModifySlice";
import userDeleteReducer from "../components/backend/user/userDeleteSlice";
import userRoleReducer from "../components/backend/userRole/allUserRoleSlice";
import userCreateRoleReducer from "../components/backend/userRole/userRoleSlice";
import userRoleModifyReducer from "../components/backend/userRole/UserRoleModifySlice";
import userRoleDeleteReducer from "../components/backend/userRole/UserRoleDeleteSlice";
import userRoleGetSliceReducer from "../components/backend/userRole/UserRoleGetSlice";
import countryListSliceReducer from "../components/backend/country/countryListSlice";
import dashboardListSliceReducer from "../components/backend/dashboard/dashboardSlice";
import productcommissionListSliceReducer from "../components/backend/commission/commissionSlice";
import productratesListSliceReducer from "../components/backend/rates/ratesSlice";
import productitenaryListSliceReducer from "../components/backend/itenary/itenarySlice";
import currencyListSliceReducer from "../components/backend/currency/currencySlice";
import citySliceReducer from "../components/backend/city/citySlice";
import serviceTypeSliceReducer from "../components/backend/serviceType/serviceTypeSlice";
import reservationEmailSliceReducer from "../components/backend/reservationemails/ReservationEmailSlice";
import ticketTypeSliceReducer from "../components/backend/ticketTypes/TicketTypeSlice";
import tourTypeSliceReducer from "../components/backend/tourTypes/TourTypeSlice";
//import supplierSliceReducer from "../components/backend/supplier/supplierSlice";
import supplierSlicesReducer from "../components/backend/suppliers/supplierSlice";
import productSlicesReducer from "../components/backend/product/productSlice";
import stopsaleSlicesReducer from "../components/backend/stopsale/stopsaleSlice";
import subproductSlicesReducer from "../components/backend/subproduct/subproductSlice";
import paxSlicesReducer from "../components/backend/paxhealth/paxhealthSlice";
import ageSlicesReducer from "../components/backend/agepolicy/agepolicySlice";
import occupancySlicesReducer from "../components/backend/occupancyrule/occupancyruleSlice";
import cancelSlicesReducer from "../components/backend/cancelpolicy/cancelpolicySlice";
import menuSliceReducer from "../components/backend/menu/menuSlice";
import rolePermissionSliceReducer from "../components/backend/userRolePermission/rolepermissionSlice";

const initialSideBarTogglerState = {
    isToggle:false
};
/* const initialloginstate = {
    isloading:false,
    islogIn:false, 
    error:''
}; */
const togglerSlice= createSlice({
    name:'adminsidebar',
    initialState:initialSideBarTogglerState,
    reducers:{
        changeToggle(state){state.isToggle=!state.isToggle}
    }
});



const store = configureStore({
    reducer:{ 
       adminsidebar : togglerSlice.reducer,  
       // authentication :authSlice.reducer,
       login : loginReducer,
       user : userReducer,
       passwordReset : passwordReducer,
       userCreate: userCreateReducer,
       allUsers: allUserReducer,
       //userProfile: userProfileReducer,
       userModify: userModifyReducer,
       userDelete: userDeleteReducer,
       allUserRoles: userRoleReducer,
       userRoleCreate: userCreateRoleReducer,
       userRoleModify: userRoleModifyReducer,
       userRoleDelete: userRoleDeleteReducer,
       userRoleGet: userRoleGetSliceReducer,
       countryList: countryListSliceReducer,
       dashboardList: dashboardListSliceReducer,
       productcommissionList: productcommissionListSliceReducer,
       productratesList: productratesListSliceReducer,
       productitenaryList: productitenaryListSliceReducer,
       currencyList: currencyListSliceReducer,
       citiesList: citySliceReducer,
       serviceTypiesList: serviceTypeSliceReducer,
       reservationEmailsList: reservationEmailSliceReducer,
       ticketTypesList: ticketTypeSliceReducer,
       tourTypesList: tourTypeSliceReducer,
       //suppliers:supplierSliceReducer,
       supplierList:supplierSlicesReducer,
       productList:productSlicesReducer,
       stopsaleList:stopsaleSlicesReducer,
       subproductList:subproductSlicesReducer,
       paxList:paxSlicesReducer,
       agepolicyList:ageSlicesReducer,
       occupancyruleList:occupancySlicesReducer,
       cancelpolicyList:cancelSlicesReducer,
	   menuList:menuSliceReducer,
       rolePermissionList:rolePermissionSliceReducer,
    }
});


export const toggleAction = togglerSlice.actions;
//export const authAction = authSlice.actions;
export default store;